import { OrderDirection } from "@bitly/sdk/dist/types"

export const truncateAddress = (address: string, first = 5, last = 5) =>
	`${address.slice(0, first)}...${address.slice(-last, address.length)}`

export const truncateString = (text: string, max = 256) => {
	if (text?.length > max) return text.substring(0, max) + ' ...'
	return text
}

export const strPadLeft = (string: string | number, pad: string, length: number) => {
	return (new Array(length + 1).join(pad) + string).slice(-length)
}

export const formatOrderId = (market: string, direction: OrderDirection, point: number) => {
	return `${market}-${direction}-${point}`
}

export const isValidAddress = (address: string) => {
	return /^0x([A-Fa-f0-9]{40})$/.test(address)
}